export default function ModifyCustomSetting(obj) {
  obj.apiUrl = obj.apiUrl1 || obj.apiUrl;
  if (obj.isDebug === false) {
    obj.apiUrl = obj.apiUrl2 || obj.apiUrl;
    return obj;
  }

  let controllerNames = [];
  for (let item in obj) {
    if (item.toLowerCase() === "ProjMgmtController".toLowerCase()) {
      controllerNames.push({
        controller: item
          .substring(0, item.toLowerCase().lastIndexOf("controller"))
          .toLowerCase()
          .replace("get", "")
          .replace("post", "")
          .replace("controller", ""),
        value: obj[item],
      });
    } else {
      if (
        item.toLowerCase().endsWith("controller") &&
        item.toLowerCase().indexOf("ProjMgmt".toLowerCase()) === -1
      ) {
        controllerNames.push({
          controller: item
            .substring(0, item.toLowerCase().lastIndexOf("controller"))
            .toLowerCase()
            .replace("get", "")
            .replace("post", "")
            .replace("controller", ""),
          value: obj[item],
        });
      }
    }
  }
  Object.keys(obj).forEach(function (k) {
    controllerNames.forEach((c) => {
      if (k.toLowerCase().indexOf(c["controller"]) !== -1) {
        obj[k] = c.value;
      }
    });
  });

  return obj;
}
